import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import { VideoMutedOverlay } from './VideoMutedOverlay';
export default angular
    .module('doxy.call.video-muted-overlay', [])
    .component('videoMutedOverlay', {
    // video-muted-overlay
    template: `<div></div>`,
    bindings: {
        textSize: '<',
        text: '@',
    },
    controller: function ($element) {
        const render = async () => {
            ReactDOM.render(React.createElement(VideoMutedOverlay, {
                textSize: this.textSize,
                text: this.text,
            }), $element[0]);
        };
        this.$onInit = render;
    },
}).name;
